import React, { memo } from 'react'
import { useTheme } from '@mui/material'
import StaticStructureShimmer, { StaticStructureShimmerProps } from './StaticStructureShimmer'

/**
 * Theme-aware static loading placeholder (no animated gradient sweep).
 * Measures child structure and fills regions with a flat background color.
 */
const SubtleShimmer: React.FC<Omit<StaticStructureShimmerProps, 'backgroundColor'> & { shimmerColor?: string; backgroundColor?: string }> = ({
    shimmerColor: _shimmerColor,
    backgroundColor,
    ...props
}) => {
    const theme = useTheme()
    const isDark = theme.palette.mode === 'dark'
    const subtleBackgroundColor = backgroundColor ?? (isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)')

    return <StaticStructureShimmer {...props} backgroundColor={subtleBackgroundColor} />
}

export default memo(SubtleShimmer)
